/* src/app/shared/components/required-indicator/required-indicator.component.scss */
.required {
  color: #686E72;
  font-size: min(85%, 12px);
}
.required.inverted {
  color: #fff;
}
/*# sourceMappingURL=required-indicator.component.css.map */
